import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { StatusOperacional } from '../../models/status-operacional.model';
import { StatusOperacionalService } from '../../services/status-operacional.servives';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-status-operacional-edit',
  templateUrl: './status-operacional-edit.component.html',
  styleUrls: ['./status-operacional-edit.component.scss']
})
export class StatusOperacionalEditComponent extends BaseFormComponent<StatusOperacional> implements OnInit {

  actionLabel: string = "Novo";
  formErrors: boolean = false;
  form: FormGroup;
  statusOperacional: StatusOperacional;
  orgaoList: any[] = [];
  questionList: any[] = [];
  questionListTable: any[] = [];
  formArray: FormArray;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public statusOperacionalService: StatusOperacionalService,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit() {
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.questionList = this.activatedRoute.snapshot.data["listQuestion"]; this.activatedRoute.snapshot.data["listQuestion"];
    this.initForm();
    this.loaded();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl(null, { validators: [Validators.required] }),
    })

    if (this.entity) {
      this.actionLabel = "Editar";
      this.form.patchValue(this.entity);
    }
  }

  getDataCreate(): StatusOperacional {
    let data: StatusOperacional;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.statusOperacionalService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: StatusOperacional) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.statusOperacionalService.create(this.getDataCreate()).subscribe({
            next: (res: StatusOperacional) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/admin-spgg/status-operacionais/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  voltar(): void {
    this.navigation.back(['projetos/admin-spgg/status-operacionais/list']);
  }
}
